// Client-side role → recommended persona mapping.
//
// Used by the chatbot picker to highlight the best-fit mentor based on a
// role the user picks themselves. Persisted to backend (`user_preferences.
// chatbot_role`) for logged-in users; falls back to localStorage for
// anonymous visitors. localStorage acts as a fast cache for both.
import { log } from "@/lib/log";

export const ROLE_OPTIONS = [
  { id: "ciso", label: "CISO / CRO", icon: "🛡️", persona: "kavya" },
  { id: "compliance", label: "Compliance / DPO", icon: "📜", persona: "priya" },
  { id: "risk_analyst", label: "Risk Analyst", icon: "📊", persona: "arjun" },
  { id: "auditor", label: "Internal Audit", icon: "🔍", persona: "arjun" },
  { id: "consultant", label: "Consultant", icon: "🎯", persona: "rishi" },
  { id: "bcm", label: "BCM / Cyber Resilience", icon: "⚡", persona: "kavya" },
  { id: "other", label: "Other / Curious", icon: "💬", persona: "rishi" },
];

export const ROLE_STORAGE_KEY = "rp_chatbot_role_v1";

const VALID_ROLE_IDS = new Set(ROLE_OPTIONS.map((r) => r.id));

export function personaForRole(roleId) {
  if (!roleId) return null;
  const match = ROLE_OPTIONS.find((r) => r.id === roleId);
  return match ? match.persona : null;
}

export function loadStoredRole() {
  if (typeof window === "undefined") return null;
  try {
    const v = window.localStorage?.getItem(ROLE_STORAGE_KEY) || null;
    return v && VALID_ROLE_IDS.has(v) ? v : null;
  } catch {
    return null;
  }
}

export function saveStoredRole(roleId) {
  if (typeof window === "undefined") return;
  try {
    if (roleId && VALID_ROLE_IDS.has(roleId)) {
      window.localStorage?.setItem(ROLE_STORAGE_KEY, roleId);
    } else {
      window.localStorage?.removeItem(ROLE_STORAGE_KEY);
    }
  } catch (err) {
    log.warn("[chatbot] role save failed:", err?.message);
  }
}
